import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService";

class KafkaService extends AxiosService {
    constructor() {
        super('log');
        this.cache = {};
        this.cacheDuration = 1000; // 1 segundo en milisegundos
        
        // Usamos arrow functions para mantener el contexto de 'this'
        this.generateCacheKey = (page, limit, search) => {
            return `${page}_${limit}_${search || ''}`;
        };
        
        this.isCacheValid = (cacheKey) => {
            const cacheItem = this.cache[cacheKey];
            if (!cacheItem) return false;
            
            const now = Date.now();
            return (now - cacheItem.timestamp) < this.cacheDuration;
        };
    }

    getKafka = async (page = 1, limit = 20, search = null) => {
        // Verificar si page o limit son nulos o undefined
        if (page === null || page === undefined || limit === null || limit === undefined) {
            return {"data": [], "pagination": {"_page": 0, "_limit": 0, "_total_pages": 0}};
        }

        if (page == 0) {
            page = 1;
        }

        const cacheKey = this.generateCacheKey(page, limit, search);
        
        // Verificar si hay una respuesta válida en caché
        if (this.isCacheValid(cacheKey)) {
            return this.cache[cacheKey].data;
        }

        let query;
        if (search) {
            query = `/kafka/messages/?page=${page}&limit=${limit}&${search}`;
        } else {
            query = `/kafka/messages/?page=${page}&limit=${limit}`;
        }
        
        const response = await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
            }
        );

        // Almacenar en caché
        this.cache[cacheKey] = {
            data: response,
            timestamp: Date.now()
        };

        return response;
    };
}

export default new KafkaService();